import CreateDocxQuizzes from '../views/CreateDocxQuizzes';
import PublisherSeries from '../views/PublisherSeries';
import NonSeriesCards from '../views/NonSeriesCards';
import SeriesCards from '../views/SeriesCards';

const router = [
  {
    path: '/publishers',
    redirect: () => ('/publishers/series'),
  },
  {
    name: 'publishers.nonSeriesCards',
    path: '/publishers/non-series-cards',
    component: NonSeriesCards,
    meta: {
      requiresAuth: true,
      requiresTeacherRole: true,
    },
  },
  {
    name: 'publishers.createDocxQuizzes',
    path: '/publishers/create-docx-quizzes',
    component: CreateDocxQuizzes,
    meta: {
      requiresAuth: true,
      requiresTeacherRole: true,
    },
  },
  {
    name: 'publishers.series',
    path: '/publishers/series',
    component: PublisherSeries,
    meta: {
      requiresAuth: true,
      requiresTeacherRole: true,
    },
  },
  {
    name: 'publishers.series.cards',
    path: '/publishers/series/:series_id',
    component: SeriesCards,
    meta: {
      requiresAuth: true,
      requiresTeacherRole: true,
    },
  },
  {
    name: 'publishers.series.chapters.createDocxQuizzes',
    path: '/publishers/series/:series_id/chapters/:chapter_id/create-docx-quizzes',
    component: CreateDocxQuizzes,
    meta: {
      requiresAuth: true,
      requiresTeacherRole: true,
    },
  },
];

export default router;



// WEBPACK FOOTER //
// ./src/app/publishers/router/index.js